import { render, staticRenderFns } from "./DASignaturePad.vue?vue&type=template&id=4c3b24e6&scoped=true"
import script from "./DASignaturePad.vue?vue&type=script&lang=js"
export * from "./DASignaturePad.vue?vue&type=script&lang=js"
import style0 from "./DASignaturePad.vue?vue&type=style&index=0&id=4c3b24e6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c3b24e6",
  null
  
)

export default component.exports